import BaseViewController from "./base-view-controller";
import { formatPhone } from "../utils/prepare-submit";
import { getFlow } from "../api/flow";

class DoctorNewViewController extends BaseViewController {
  prepareSubmit(values) {
    values = formatPhone(values, "phone_faxes.0.");
    values = formatPhone(values, "phone_faxes.1.");
    return values;
  }

  handleButtonClick(name) {
    if (["saveButton"].includes(name)) {
      getFlow({
        url: this.screen.action.value,
        formState: this.prepareSubmit(this.appData.values)
      }).then(() => {
        super.handleButtonClick(
          name,
          {},
          {
            type: "url",
            value: "/screens/doctors"
          },
          2
        );
      });
    }
  }
}

export default DoctorNewViewController;
